export enum MfaStatusType {
  MFA_REQUIRED = 'mfaRequired',
  TOKEN_EXPIRED = 'tokenExpired',
  TOKEN_INVALID = 'tokenInvalid',
  SUCCESS = 'success',
  ACCOUNT_LOCKED = 'accountLocked',
  INVALID_CREDENTIALS = 'invalidCredentials',
  OIDC_REQUIRED = 'oidcRequired',
  OIDC_CODE_EXPIRED = 'oidcCodeExpired',
}

export enum VerificationStatusType {
  APPROVED = 'approved',
  PENDING = 'pending',
  CANCELED = 'canceled',
  VERIFIED = 'verified',
  UNVERIFIED = 'unverified',
  NOT_FOUND = '404',
}

export enum DefaultPasswordLength {
  EMPLOYEE = 16,
  CLIENT = 10,
}

export enum SessionStatusType {
  SESSION_EXPIRED = 'sessionExpired',
}

export enum ReauthenticatedRouteFailureStatus {
  INVALID_CREDENTIALS = 'invalid_credentials',
  LOCKED_OUT = 'locked_out',
  OIDC_REQUIRED = 'oidc_required',
  UNKNOWN_ERROR = 'unknown_error',
}

export enum AccountValidationFailureStatus {
  EMAIL_NOT_ALLOWED = 'invalid_email',
  ROLE_NOT_ALLOWED = 'invalid_role',
  PERSONA_NOT_ALLOWED = 'invalid_persona',
}

export enum OneTimeTokenRouteFailureStatus {
  INVALID_TOKEN = 'invalid_token',
  EXPIRED_TOKEN = 'expired_token',
  TOKEN_ALREADY_USED = 'token_already_used',
}

export enum ClaimEmailFailureStatus {
  INVALID_EMAIL = 'invalid_email',
  EMAIL_IN_USE = 'email_in_use',
}

export const InviteBulkStatus = {
  ...ClaimEmailFailureStatus,
  ...AccountValidationFailureStatus,
  SUCCESS: 'success' as const,
};

export const ClaimEmailStatus = {
  ...ClaimEmailFailureStatus,
  ...OneTimeTokenRouteFailureStatus,
  SUCCESS: 'success' as const,
};

export const UpdateSensitivePropertyStatus = ClaimEmailFailureStatus;

export enum ChangePasswordForSelfStatus {
  INVALID_PASSWORD = 'invalid_password',
  EMAIL_FAILED_TO_SEND = 'email_failed_to_send',
  SUCCESS = 'success',
}

export enum InvitesAcceptStatus {
  SUCCESS = 'success',
  INVALID_PASSWORD = 'invalid_password',
}

export enum UserUpdateFailureStatus {
  NO_PERMISSION = 'no_permission',
  MFA_METHOD_DOESNT_EXIST = 'mfa_method_doesnt_exist',
  MFA_METHOD_NOT_VERIFIED = 'mfa_method_not_verified',
}
